// ===== CONSTANTES =====

export const N8N_WEBHOOK_URL =
  typeof window !== "undefined" &&
  (window as any).BUN_PUBLIC_N8N_WEBHOOK_URL
    ? (window as any).BUN_PUBLIC_N8N_WEBHOOK_URL
    : "https://brennovic08.app.n8n.cloud/webhook/chatbot-educacional";

export const INITIAL_MESSAGE = {
  id: "1",
  role: "assistant" as const,
  content:
    "Olá! Sou um assistente especializado em análise de materiais didáticos. Posso te ajudar a:\n\n" +
    "* **Analisar PDFs de provas e avaliações:** Identificar o tema, a estrutura, a adequação ao nível da turma, sugerir melhorias e relacionar com a BNCC.\n\n" +
    "* **Analisar conteúdos didáticos:** Extrair conceitos principais, identificar dificuldades dos alunos, sugerir atividades complementares e propor abordagens pedagógicas variadas.\n\n" +
    "É só me enviar o material que você quer que eu analise! 😊",
  timestamp: new Date(),
};

export const INTENT_KEYWORDS = {
  alunosRisco: [
    "aluno",
    "risco",
    "atenção",
    "dificuldade",
    "com problemas",
  ],
  desempenhoTurma: ["turma", "desempenho", "como está", "análise"],
  criarAtividade: ["criar", "gerar", "atividade", "exercício"],
  planoAula: ["plano", "aula", "ensino"],
  analiseDesempenho: [
    "dashboard",
    "panorama",
    "visão geral",
    "análise",
    "desempenho geral",
  ],
};

export const ERROR_MESSAGES = {
  notAuthenticated: "❌ Erro: Você precisa estar autenticado para usar o assistente.",
  webhookNotConfigured: "❌ Erro de configuração: URL do webhook não definida.",
  pdfAnalysisError: "❌ Erro ao analisar PDF. Verifique se o arquivo é válido.",
  webhookError: "❌ Erro interno no N8N. Verifique os logs do webhook.",
  processingError:
    "❌ Desculpe, ocorreu um erro ao processar sua solicitação. Por favor, tente novamente!\n\n" +
    "Se o erro persistir, verifique:\n" +
    "• N8N está rodando\n" +
    "• Webhook URL está correta\n" +
    "• Sua conexão com a internet está estável",
};

export const LOADING_MESSAGE =
  "Analisando dados...";

export const PDF_ANALYSIS_TEMPLATE = `📄 **Análise do PDF:**\n\n` +
  `• **Tipo:** Plano de aula/Atividade\n` +
  `• **Páginas detectadas:** {pages}\n` +
  `• **Tópicos identificados:** {topics}\n` +
  `• **Nível de dificuldade:** {difficulty}\n` +
  `• **Adequado para:** {targetAudience}\n\n` +
  `💡 **Sugestões:**\n` +
  `- Adicionar mais exercícios práticos\n` +
  `- Incluir exemplos do cotidiano\n` +
  `- Criar questões progressivas (fácil → difícil)`;
